export default __webpack_public_path__ + "static/media/stability-growth.bb7866bd.png";